





























































































































































import { serialize } from "class-transformer";
import { Component, Inject, Mixins, Watch } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import MaltaModule, { MODULE_ID, PORTAL_TARGET } from "../../index";
import BeforeUnload from "../../mixins/BeforeUnload";
import ProjectProposalMixin from "../../mixins/ProjectProposal";
import Utils from "../../mixins/Utils";
import FormDirtyOnLeavePage from "../private/forms/FormDirtyOnLeavePage.vue";
import { LocationInvestmentParcels, DownloadFileParams } from "../../models/ProjectProposal";
import { BulkPrintQueueData, PrintQueueData } from "../../models/Contract";

const TIMEOUT = 30000;

@Component({
    beforeRouteLeave(
        this: ProjectProposalLocationInvestmentOnFarm,
        to: Route,
        from: Route,
        next: NavigationGuardNext<Vue>
    ) {
        this.isDirty ? (this.showModal = true) : next();
    },
    components: {
        FormDirtyOnLeavePage
    }
})
export default class ProjectProposalLocationInvestmentOnFarm extends Mixins(ProjectProposalMixin, Utils, BeforeUnload) {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;

    response: LocationInvestmentParcels | null = null;
    total = 0;
    loading = true;
    originalData = "";
    showModal = false;
    isDirty = false;
    isValid: string[] = [];
    selectedParcels: LocationInvestmentParcels | null = null;
    printId = "LPIS_REFERENCE_PARCEL_173_5";
    downloadData: PrintQueueData | null = null;
    downloadBulkData: BulkPrintQueueData | null = null;
    timeoutId: number | null = null;
    printParameter = "";
    downloadFileParams: DownloadFileParams = {
        mime_type: "application/pdf",
        extension: "pdf"
    };
    printMsgKey = "";

    @Watch("response", { deep: true })
    onRowsChange() {
        this.setBeforeUnload();
    }

    async mounted() {
        await this.loadParcels();
    }

    async loadParcels() {
        this.loading = true;
        const [data, err] = await this.maltaModule.projectProposalApi.getLocationInvestmentParcels(
            this.subjectId,
            this.applicationId
        );
        if (err) {
            if (err.response && err.response.status !== 404) {
                this.goHomeGenericError();
            } else {
                this.response = null;
            }
        } else if (data) {
            // debugger
            this.originalData = serialize(data);
            this.response = data;
        }
        this.loading = false;
    }

    backToHome(force = false) {
        if (force) {
            this.unsetBeforeUnload();
            this.originalData = serialize(this.response);
        }
        this.isDirty = this.originalData !== serialize(this.response);
        this.goHome();
    }

    async saveAndGoBack() {
        this.loading = true;
        if (this.response) {
            const [data, err] = await this.maltaModule.projectProposalApi.setLocationInvestmentParcels(
                this.subjectId,
                this.applicationId,
                this.response
            );
            if (err) {
                this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
            } else if (data) {
                this.unsetBeforeUnload();
                this.originalData = serialize(data);
                this.response = data;
                this.isDirty = false;
                this.$emit("reload");
                this.toast(this.i18n("saved-successfully").toString(), { type: "success" });
                this.goHome(true);
            }
        } else this.toast(this.i18n("saved-successfully").toString(), { type: "success" });
        this.loading = false;
    }

    beforeDestroy() {
        this.unsetBeforeUnload();
    }

    get portalTarget(): string {
        return PORTAL_TARGET;
    }

    // DOWNLOAD PDF Button

    private async getDownloadQueue(parcelId: number): Promise<void> {
        this.loading = true;
        this.printMsgKey = "APP_" + this.subjectId + "_" + this.applicationId + "_" + parcelId + "_" + this.printId;

        const [downloadData] = await this.maltaModule.maltaApi.getDownloadQueue(
            this.subjectId,
            this.applicationId,
            this.printId,
            this.printMsgKey
        );
        this.downloadData = downloadData;
        if (this.downloadData) {
            if (this.downloadData.queued) {
                this.loading = this.downloadData.queued;
                this.timeoutId = setTimeout(async () => await this.getDownloadQueue(parcelId), 5000);
            } else {
                if (this.downloadData.queue_result === "Done") {
                    await this.downloadFile(this.downloadData.file_id);
                } else if (this.downloadData.queue_result === "Error") {
                    this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
                    this.loading = false;
                }
            }
        } else {
            this.loading = false;
        }
    }

    private async downloadFile(fileId: number): Promise<void> {
        const [resp, err] = await this.maltaModule.maltaApi.getDownloadFile(
            this.subjectId,
            this.applicationId,
            fileId,
            this.downloadFileParams
        );

        if (err) {
            this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
        }

        if (resp) {
            const blob = new Blob([new Uint8Array(resp.data)], { type: resp.contentType });
            const src = URL.createObjectURL(blob);
            const anchor = document.createElement("a") as HTMLAnchorElement;
            anchor.href = src;
            anchor.download = resp.filename;
            anchor.style.visibility = "hidden";
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            setTimeout(() => {
                URL.revokeObjectURL(src);
            }, TIMEOUT);
        }
        this.loading = false;
    }

    async downloadRequestHandler(parcelId: number): Promise<void> {
        this.loading = true;
        this.printParameter = "ID_PARTICELLA=" + parcelId;
        this.printMsgKey = "APP_" + this.subjectId + "_" + this.applicationId + "_" + parcelId + "_" + this.printId;
        const [downloadData] = await this.maltaModule.maltaApi.performDownload(
            this.subjectId,
            this.applicationId,
            this.printId,
            this.printParameter,
            this.printMsgKey
        );
        this.downloadData = downloadData;

        if (this.downloadData) {
            this.loading = this.downloadData.queued;
            if (this.downloadData.queued) {
                await this.getDownloadQueue(parcelId);
            } else {
                if (this.downloadData.queue_result === "Done") {
                    await this.downloadFile(+this.downloadData.file_id);
                } else if (this.downloadData.queue_result === "Error") {
                    this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
                    this.loading = false;
                }
            }
        } else {
            this.loading = false;
        }
    }
    // Add this method in MaltaApi class

    // Download all certificates as ZIP
    private async getZipDownloadQueue(downloadBulkData: BulkPrintQueueData | null): Promise<void> {
        if (downloadBulkData) {
            const [downloadData] = await this.maltaModule.maltaApi.getZipDownloadQueue(
                this.subjectId,
                this.applicationId,
                this.printId,
                downloadBulkData
            );
            this.downloadBulkData = downloadData;
            if (this.downloadBulkData) {
                if (this.downloadBulkData.queued) {
                    this.loading = this.downloadBulkData.queued;
                    this.timeoutId = setTimeout(async () => await this.getZipDownloadQueue(downloadBulkData), 5000);
                } else {
                    if (this.downloadBulkData.queue_result === "Done") {
                        await this.downloadAllCertificates(this.downloadBulkData);
                    } else if (this.downloadBulkData.queue_result === "Error") {
                        this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
                        this.loading = false;
                    }
                }
            } else {
                this.loading = false;
            }
        } else {
            this.loading = false;
        }
    }

    async downloadZipRequestHandler(): Promise<void> {
        this.loading = true;
        const [downloadData] = await this.maltaModule.maltaApi.performZipDownload(
            this.subjectId,
            this.applicationId,
            this.printId
        );
        this.downloadBulkData = downloadData;

        if (this.downloadBulkData) {
            this.loading = this.downloadBulkData.queued;
            if (this.downloadBulkData.queued) {
                await this.getZipDownloadQueue(this.downloadBulkData);
            } else {
                if (this.downloadBulkData.queue_result === "Done") {
                    await this.downloadAllCertificates(this.downloadBulkData);
                } else if (this.downloadBulkData.queue_result === "Error") {
                    this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
                    this.loading = false;
                }
            }
        } else {
            this.loading = false;
        }
    }

    async downloadAllCertificates(downloadBulkData: BulkPrintQueueData | null): Promise<void> {
        if (downloadBulkData) {
            const [resp, err] = await this.maltaModule.maltaApi.downloadAllCertificates(
                this.subjectId,
                this.applicationId,
                this.printId,
                downloadBulkData
            );
            this.loading = false;
            if (err) {
                this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
                return;
            }
            if (resp) {
                const blob = new Blob([new Uint8Array(resp.data)], { type: resp.contentType });
                const src = URL.createObjectURL(blob);
                const anchor = document.createElement("a") as HTMLAnchorElement;
                anchor.href = src;
                anchor.download = resp.filename;
                anchor.style.visibility = "hidden";
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
                setTimeout(() => {
                    URL.revokeObjectURL(src);
                }, TIMEOUT);
            }
        }
    }
}
